<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >{{ data.descripcion }} {{ data.atributos.join(", ") }}</span
            >
            <button
                mat-icon-button
                aria-label="Close dialog"
                (click)="dialogRef.close()"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <div>
            <mat-list>
                <mat-list-item *ngIf="data.condicion">
                    <h3 matLine>Condición</h3>
                    <p matLine>
                        <span class="secondary-text">{{
                            data.condicion.descripcion
                        }}</span>
                    </p>
                </mat-list-item>

                <mat-list-item>
                    <h3 matLine>Observaciones</h3>
                    <p matLine>
                        <span
                            class="secondary-text"
                            *ngIf="data.descripcionSolicitud"
                        >
                            {{ data.descripcionSolicitud }}
                        </span>
                    </p>
                </mat-list-item>
                <mat-list-item>
                    <h3 matLine>Tiempo duración trabajo</h3>
                    <p matLine>
                        <span class="secondary-text">
                            {{ data.tiempoTrabajo }}
                        </span>
                    </p>
                </mat-list-item>
                <mat-list-item>
                    <h3 matLine>Descripción trabajo</h3>
                    <p matLine>
                        <span class="secondary-text">
                            {{ data.descripcionTrabajo }}
                        </span>
                    </p>
                </mat-list-item>

                <mat-list-item *ngIf="!data.aceptada && data.comentario">
                    <h3 matLine>Motivo rechazo</h3>
                    <p matLine>
                        <span class="secondary-text">
                            {{ data.comentario }}
                        </span>
                    </p>
                </mat-list-item>

                <mat-list-item *ngIf="data.conAdjunto">
                    <h3 matLine>Documento adjunto</h3>
                    <p matLine>
                        <button
                            mat-button
                            color="accent"
                            (click)="
                                verAdjunto(data.idServicioSolicitudCotizacion)
                            "
                        >
                            <mat-icon>cloud_download</mat-icon>
                            Descargar
                        </button>
                    </p>
                </mat-list-item>
            </mat-list>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-raised-button color="accent" mat-dialog-close>
            Cerrar
        </button>
    </mat-dialog-actions>
</div>
